import React, { useState, useEffect } from 'react' 
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { useGetUser } from '../../../hooks/useGetUser';
import { Select, MenuItem, InputLabel, RadioGroup, FormControlLabel, Radio,
         FormLabel, createMuiTheme, MuiThemeProvider, Checkbox } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/pt-br"
import FormData from 'form-data'
import styles from './styles.module.scss'
import ButtonsImagesCampain from '../../../components/ButtonsImagesCampain'
import { postBanner, putBanner, getBannerWithId } from '../../../services/api-auto';

import { useDispatch } from "react-redux"
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';

import ModalLoading from '../../../components/ModalLoading'

const dataInit = {
    id: '',
    periodoIndeterminado: true,
    dataTermino: moment(),
    status: 1,
    titulo: '',
    tipo: 0,
    ordem: 0,
    link: '',
    ImagemDestaqueDesktop: null,
    ImagemDestaqueDesktopBlob: null,
    ImagemDestaqueMobile: null,
    ImagemDestaqueMobileBlob: null,
}

const Detalhes = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const history = useHistory()
    const [data, setData] = useState(dataInit);

    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const validarForm = () => {
        let valid = true
        let msg = ""

        if(!data.titulo){
            let msg = `Campo Titulo obrigatório`; 
            valid = false; 
            showMsgW(msg)
        }
        // if(!data.link){
        //     msg = "Campo Link é obrigatório\n"; 
        //     valid = false; 
        //     showMsgW(msg)
        // }
        if(!data.dataTermino){
            msg = "Campo Ordem é obrigatório\n"; 
            valid = false; 
            showMsgW(msg)
        }
        if(data.ordem <= 0){
            msg = "A Ordem não pode ser zero e nem negativo\n"; 
            valid = false; 
            showMsgW(msg)
        }
        
        return valid
    }

    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
      
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
      
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
      
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    const getBannerIfEdit = async (id) => {
        if(id){
            setModalLoading(true)
            try{
                const info = await getBannerWithId(id);

                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64data = reader.result;    
                }


                setData({
                    ...data,
                    id: info.data.id, 
                    periodoIndeterminado: info.data.periodoIndeterminado,
                    dataTermino: moment(info.data.dataTermino),
                    status: info.data.status,
                    titulo: info.data.titulo,
                    tipo: info.data.tipo,
                    ordem: info.data.ordem,
                    link: info.data.link,
                    ImagemDestaqueDesktop: null,
                    ImagemDestaqueDesktopBlob: b64toBlob(info.data.imagemDestaqueDesktop.fileContents, info.data.imagemDestaqueDesktop.contentType),
                    ImagemDestaqueMobile: null,
                    ImagemDestaqueMobileBlob:  b64toBlob(info.data.imagemDestaqueMobile.fileContents, info.data.imagemDestaqueMobile.contentType),
                })

            } catch(e){
                showMsgW('Não foi possível carregar os dados')
            }
            setModalLoading(false)
        }
    }

    const createSenderForm = () => {
        let formdata = new FormData();

        if( data.id !== '' ){ formdata.append("id", data.id); }
        formdata.append("titulo", data.titulo)
        formdata.append('dataTermino', data.dataTermino.format('DD/MM/YYYY'))
        formdata.append('Tipo', data.tipo)
        formdata.append('Status', data.status)
        formdata.append('periodoIndeterminado', data.periodoIndeterminado)
        formdata.append('ordem', data.ordem)
        formdata.append('link', data.link)
        formdata.append('ImagemDestaqueDesktop', data.ImagemDestaqueDesktop)
        formdata.append('ImagemDestaqueMobile', data.ImagemDestaqueMobile)

        return formdata;
    }

    const enviar = async() => {
        setIndicarErros(false)

        if(validarForm()){
            let formdata = createSenderForm()
            setModalLoading(true)
            try{
                const info = ( data.id === '' || data.id === undefined || data.id === null) ? await postBanner(formdata) : await putBanner(formdata)

                showMsgS("Dados salvos com sucesso!")
                setTimeout(()=>{
                    history.push('/banner')
                }, 2000)

            } catch(e){
                e.response ? showMsgE(e.response.data) : showMsgE("Ocorreu um erro ao salvar os dados")
            } finally {
                setModalLoading(false)
            }
        }
    }

    useEffect( () => {
        getBannerIfEdit();
        const banner = new URLSearchParams(history.location.search).get("banner")
        getBannerIfEdit(banner)
    },[])

    const user = useGetUser();

    return (
        <>
            {( user.perfilAcesso === 'Master' ) && (
                <>
                    <div className={styles.wrapper}>
                        <div className={styles.title}>
                            Cadastro de Banner
                            <button className={styles.backButton} onClick={() => {history.goBack()}}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                        </div>
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                                    <FormControl className={styles.half}>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, titulo:e.target.value})}}
                                            label="Titulo"
                                            value={data.titulo}
                                            variant="filled"
                                            error={indicarErros && !data.titulo ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl className={styles.half}>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, link:e.target.value})}}
                                            label="Link"
                                            value={data.link}
                                            variant="filled"
                                            error={indicarErros && !data.link ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl className={styles.third}>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, ordem:e.target.value})}}
                                            label="Ordem"
                                            value={data.ordem}
                                            variant="filled"
                                            error={indicarErros && !data.ordem ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl className={styles.third}>
                                        <InputLabel id="select-tipo-label" className={styles.label}>
                                            Tipo
                                        </InputLabel>
                                        <Select
                                            labelId='select-tipo-label'
                                            label="Tipo"
                                            onChange={(e)=>{setData({...data, tipo: e.target.value})}}
                                            value={data.tipo}
                                            variant='filled'
                                            className="customFilledInput"
                                        >
                                            <MenuItem value={0}>Home</MenuItem>
                                            <MenuItem value={1}>VitrineBV</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl className={styles.third}>
                                        <InputLabel id="select-status-label" className={styles.label}>
                                            Status
                                        </InputLabel>
                                        <Select
                                            labelId='select-status-label'
                                            label="Status"
                                            onChange={(e)=>{setData({...data, status: e.target.value})}}
                                            value={data.status}
                                            variant="filled"
                                            className="customFilledInput"
                                        >
                                            <MenuItem value={0}>Inativo</MenuItem>
                                            <MenuItem value={1}>Ativo</MenuItem>
                                        </Select>
                                    </FormControl>
                                    
                                    <div className={styles.topSpacing}>
                                        <div className={styles.subtitleConfiguracao}>
                                            Período de Atividade
                                        </div>
                                        <div className={styles.atividade}>
                                            <FormControl component="fieldset">
                                                <FormControlLabel value="Indeterminado" control={
                                                    <Checkbox style={{color: '#5CCBE1' }}
                                                        checked={data.periodoIndeterminado}
                                                        onChange={e => {setData({...data, periodoIndeterminado: true})}}
                                                    />
                                                } label="Indeterminado" className={styles.radioOptions}/>
                                            </FormControl>
                                            <FormControl component="fieldset">
                                                <FormControlLabel value="Determinado" control={
                                                    <Checkbox style={{color: '#5CCBE1' }}
                                                        checked={!data.periodoIndeterminado}
                                                        onChange={e => {setData({...data, periodoIndeterminado: false})}}
                                                    />
                                                } label="Determinado"  className={styles.radioOptions}/>
                                            </FormControl>
                                            {
                                                (!data.periodoIndeterminado) ? (
                                                    <FormControl className={styles.third}>
                                                        <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                variant="inline"
                                                                inputVariant="outlined"
                                                                label="Ativo até"
                                                                format="DD/MM/yyyy"
                                                                value={data.dataTermino}
                                                                InputAdornmentProps={{ position: "start" }}
                                                                onChange={novaData => { setData({ ...data, dataTermino:novaData}) }}
                                                                className="customFilledInput"
                                                                error={indicarErros && !data.dataTermino ? true : false}
                                                                invalidDateMessage="Data em formato inválido."
                                                                maxDateMessage="Data não deve ser maior que a data máxima."
                                                                minDateMessage="Data não deve ser menor que a data mínima."
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </FormControl>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>
                                        Imagens
                                    </div>
                                    <div className={styles.divImageList}>
                                        <ButtonsImagesCampain
                                            smallText = 'Versão Desktop'
                                            texto = 'Destaque que será exibido no portal do participante.'
                                            width = '1200'
                                            height = '300'
                                            widthMM = '317.5'
                                            heightMM = '79.375'
                                            image={data.ImagemDestaqueDesktop}
                                            blob={data.ImagemDestaqueDesktopBlob}
                                            changeImage={(file)=>{setData({...data, 'ImagemDestaqueDesktop':file})}}
                                            error={indicarErros && !data.ImagemDestaqueDesktop && !data.ImagemDestaqueDesktop ? true : false}
                                        />
                                        <ButtonsImagesCampain
                                            smallText = 'Versão Mobile'
                                            texto = 'Destaque que será exibido no portal do participante.'
                                            width = '400'
                                            height = '400'
                                            widthMM = '132.29'
                                            heightMM = '132.29'
                                            image={data.ImagemDestaqueMobile}
                                            blob={data.ImagemDestaqueMobileBlob}
                                            changeImage={(file)=>{setData({...data, 'ImagemDestaqueMobile':file})}}
                                            error={indicarErros && !data.ImagemDestaqueMobile && !data.ImagemDestaqueMobile ? true : false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <button className={styles.salvar} onClick={enviar}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />

                </>
            )}
            
        </>
    );
}

export default Detalhes;